import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const usePaginationSync = (lastPage) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(() => {
    const params = new URLSearchParams(location.search);
    const pageParam = parseInt(params.get("page"), 10);
    return !isNaN(pageParam) && pageParam > 0 ? pageParam : 1;
  });

  // When the URL changes, update the local state immediately
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageParam = parseInt(params.get("page"), 10);

    if (!isNaN(pageParam) && pageParam !== currentPage) {
      setCurrentPage(Math.min(pageParam, lastPage));
    }
    if (pageParam > lastPage) return setCurrentPage(lastPage);
    // eslint-disable-next-line
  }, [location.search, lastPage]);

  const updatePage = (newPage) => {
    if (newPage > 0 && newPage <= lastPage) {
      navigate(`?page=${newPage}`, { replace: false });
    }
  };

  return { currentPage, updatePage };
};

export { usePaginationSync };
